import { render, staticRenderFns } from "./GoodsRead.vue?vue&type=template&id=1535c4ea&"
import script from "./GoodsRead.vue?vue&type=script&lang=js&"
export * from "./GoodsRead.vue?vue&type=script&lang=js&"
import style0 from "./GoodsRead.vue?vue&type=style&index=0&id=1535c4ea&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports